export const initAccessibility = () => {
  /**
 * Accessibility | Prefers reduced motion
 * - Deactivates GSAP Motion if user have this opiton activated on their broweser.
 */
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    document.body.classList.add("prefers-reduced-motion");
  } else {
    document.body.classList.remove("prefers-reduced-motion");
  }
}